document.addEventListener("DOMContentLoaded", function () {
    function initDateFields() {
        const dateFields = document.querySelectorAll('input[name="due_date"]');
        dateFields.forEach(item => {
            if (item._flatpickr) {
                item._flatpickr.redraw();

                return;
            }

            item.setAttribute('placeholder', 'gg/mm/aaaa');
            const wrapper = item.closest('.column label');
            if (!wrapper) return;
            wrapper.style.position = 'relative';

            const icon = document.createElement('span');
            icon.classList.add('form-icon-date');
            wrapper.appendChild(icon);

            flatpickr(item, {
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d.m.Y",
                allowInput: true,
                locale: "it",
                minDate: new Date(),
            });
        });
    }

    function initPhone() {
        const phoneInput = document.querySelectorAll('input[name="phone"]');
        if (phoneInput.length < 1) return;

        phoneInput.forEach((el) => {
            el.addEventListener('input', () => {
                let value = el.value;

                value = value.replace(/[^+\d]/g, '');

                if (value.includes('+')) {
                    value = '+' + value.replace(/\+/g, '');
                }

                value = value.slice(0, 13);

                el.value = value;
            });

            el.addEventListener('blur', () => {
                const val = el.value.replace(/\D/g, '');

                if (val.length > 0 && /^(\d)\1+$/.test(val)) {
                    el.value = '';
                }
            });

        })
    }

    function initPages() {
        const pagesInputs = document.querySelectorAll('input[name="pages"]');
        if (pagesInputs.length < 1) return;

        pagesInputs.forEach((el) => {
            el.addEventListener('input', () => {
                el.value = el.value.replace(/\D/g, '').slice(0, 3);
            });
        });
    }

    initPages();
    initPhone();
    initDateFields();
});
